import { Text } from 'blaze-ui/Text/Text'
import Styles from './SliderField.module.scss'

import { SliderFieldProps } from './Types'
import { SafeNumberInput } from 'almanac-ui/TextInputField/SafeNumberInput'
import { Slider } from 'almanac-ui/Slider/Slider'
import { flatten } from 'lodash'
import { useLabel } from '@react-aria/label'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const SliderField = ({
  step = 1,
  minValue = 0,
  maxValue = 100,
  value,
  pinnedValue,
  onChange,
  label,
  isDisabled,
  size = 'sm',
  unit,
  withInput = true,
}: SliderFieldProps) => {
  const { labelProps, fieldProps } = useLabel({ label })
  const { isMobile } = useResponsiveDesign()

  const updateValue = (val: number) => {
    if (minValue != null && val < minValue) return onChange(minValue)
    if (maxValue != null && val > maxValue) return onChange(maxValue)
    return onChange(val)
  }

  return (
    <div className={Styles.field}>
      <Text variant="smallList" {...labelProps}>
        {label}
      </Text>
      {withInput && (
        <div className={Styles.input}>
          {unit && (
            <Text variant="metadata" color="var(--dark-40)">
              {unit}
            </Text>
          )}
          <SafeNumberInput
            aria-label={label}
            className={Styles.numberInput}
            name={label}
            size={size}
            value={value}
            placeholder="--"
            onChange={onChange}
            step={step}
            minValue={minValue}
            maxValue={maxValue}
            disabled={isDisabled}
            withBorder={false}
            autoComplete="off"
          />
        </div>
      )}
      <div className={Styles.slider}>
        <Slider
          {...fieldProps}
          value={value}
          onChange={(value) => updateValue(flatten([value])[0])}
          step={step}
          minValue={minValue}
          maxValue={maxValue}
          pinnedValue={pinnedValue}
          isDisabled={isDisabled}
          size={isMobile ? 'xlThumb' : 'sm'}
          filled
        />
      </div>
    </div>
  )
}

export { SliderField }
